import request from '../../axios';

const postSaleAgents = async (payload: ISaleAgentsPayload) => {
  await request.post(`api/v2/store/add-sale-agent`, payload);
};

export default postSaleAgents;
